import { useState, useEffect } from 'react'
import { Button, Icon, Select, Progress } from 'semantic-ui-react'
import { ReadinessStep } from './ReadinessStep'
import { ChecklistStep } from './ChecklistStep'
import { filterDataByTeam, canEditLimited } from '../auth'
import { getTeams, getTeamDetails } from '../common/apiClient'
import { FinishedStep } from './FinishedStep'
import { GlobalContext } from '../../App'
import { useContext } from 'react'
import { Link } from 'react-router-dom'
import './Onestop.css'

export function updateStorage(key, value) {
    const sessionStorageProgress = sessionStorage.getItem('onestop-progress')
    if (sessionStorageProgress) {
        const currProgress = JSON.parse(sessionStorageProgress)
        currProgress[key] = value
        sessionStorage.setItem('onestop-progress', JSON.stringify(currProgress))
    } else {
        const currProgress = {}
        currProgress[key] = value
        sessionStorage.setItem('onestop-progress', JSON.stringify(currProgress))
    }
}

export function getStorage() {
    const sessionStorageProgress = sessionStorage.getItem('onestop-progress')
    if (sessionStorageProgress) {
        return JSON.parse(sessionStorageProgress)
    } else {
        return null
    }
}

export function setStorage(value) {
    sessionStorage.setItem('onestop-progress', JSON.stringify(value))
}

export const Step = props => {
    if (props.hideIcon) {
        return <div className="onestop-step">
            {props.children}
        </div>
    } else {
        return <div className="onestop-step">
            {props.children}
        </div>
    }
}

export const Onestop = props => {
    /*

    1. Has your readiness changed from your last report?
        - Includes sick team members who are back, assets
          which work now or are broken, etc
    2. Has the composition of your team changed?
        - Includes whether you have added or removed members
          or assets
    3. Have you completed or incompleted the following checklists?
        - Lists checklists associated with this team

    */

    const [team, setTeam] = useState(0)
    const [teams, setTeams] = useState([])
    const sessionStorageProgress = sessionStorage.getItem('onestop-progress')
    const [currStep, setCurrStep] = useState(sessionStorageProgress ? JSON.parse(sessionStorageProgress).step : 0)
    const [teamsLoaded, setTeamsLoaded] = useState(true)
    const { setShowOnestopOverlay } = useContext(GlobalContext)

    if(currStep > 0 && currStep < 3) {
        setShowOnestopOverlay(true)
    } else {
        setShowOnestopOverlay(false)
    }

    async function getTeamsOuter() {
        setTeamsLoaded(false)
        const respJson = await getTeams()
        let user_info = filterDataByTeam()
        if (user_info && user_info.filterData) {
            let filtered_teams_data = respJson.filter(function (o) {
                return (o.members.includes(user_info.name));
            });
            setTeams(filtered_teams_data)
        } else {
            setTeams(respJson)
        }
        setTeamsLoaded(true)
    }

    function nextStep() {
        if (currStep === 4) {
            return
        }
        setCurrStep(currStep + 1)
    }

    function previousStep() {
        if (currStep === 0) {
            return
        }
        setCurrStep(currStep - 1)
    }

    function goToStep(step) {
        setCurrStep(step)
    }

    const getTeamDetailsOuter = async (id) => {
        const response = await getTeamDetails(id)
        setTeam(response)
    }

    async function handleTeamChange(event, data) {
        if (!data.value) {
            sessionStorage.setItem('onestop-progress', JSON.stringify({ step: 0 }))
            setTeam({})
        } else {
            getTeamDetailsOuter(data.value)
            sessionStorage.setItem('onestop-progress', JSON.stringify({ step: 0, team: data.value }))
        }
    }

    useEffect(() => {
        updateStorage('step', currStep)
    }, [currStep])

    useEffect(() => {
        getTeamsOuter()
        const currProgress = getStorage()
        if (currProgress && currProgress.team) {
            getTeamDetailsOuter(currProgress.team)
        } else {
            setCurrStep(0)
            setStorage({
                'step': 0,
                'team': null
            })
        }
        const userInfo = filterDataByTeam()
        if(userInfo.associatedTeamsIds.length === 1 && canEditLimited() && !currProgress.team) {
            getTeamDetailsOuter(userInfo.associatedTeamsIds[0])
            setStorage({
                'step': 0,
                'team': userInfo.associatedTeamsIds[0]
            })
        }
    }, [])

    return <div id="onestop-wrapper">
        <div id="nav-arrows">
            <Link><Icon onClick={previousStep} disabled={currStep === 0} size="big" className="arrow circle left" /></Link>
            <Progress value={currStep + 1} total='4' progress="ratio" success={currStep === 3} style={{ width: "80%", margin: "0.5rem" }} />
            <Link><Icon onClick={nextStep} disabled={currStep === 4 || !team.id} size="big" color="blue" className="arrow circle right" /></Link>
        </div>

        {currStep === 0 && <Step completed={team.id}>
            <div className="onestop-header">Select your team</div>
            <Select
                search
                options={
                    teams.map((t) => {
                        return {
                            id: t.id,
                            value: t.id,
                            text: t.name
                        }
                    })
                }
                onChange={handleTeamChange}
                value={team.id}
                clearable
                loading={!teamsLoaded} />
            <Button disabled={!team.id} onClick={() => nextStep()} style={{ margin: "1rem" }}>Next</Button>
        </Step>}
        {currStep === 1 && <ReadinessStep team={team} nextStep={nextStep} />}
        {currStep === 2 && <ChecklistStep team={team} nextStep={nextStep} />}
        {currStep === 3 && <FinishedStep team={team} goToStep={goToStep} />}
    </div>
}